import { CohortParticipant } from "sdk/cohort";
import { useCohortIndexQuery } from "~/store/api";

export const useCohortCurrentUserParticipant = ():
  | CohortParticipant
  | undefined => {
  const { isLoading, data } = useCohortIndexQuery();

  if (isLoading || !data) return undefined;
  const { participants } = data;

  const participant = participants.find(
    (participant) => participant.type === "currentUser",
  );

  return participant;
};
